import { FeatheredImage } from "../../FeatheredImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-about-pink-sweater-floor.jpg`;
const ALT = "Lara sitting cross-legged on a plush rug in a pink sweater, typing on her laptop in a bright, colorful living room.";

const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[8px] px-7 py-3.5 text-base font-medium hover:bg-[#e8463c] transition-colors";
const btnSecondary =
  "inline-flex items-center justify-center gap-2 border-2 border-[#1C1917] text-[#1C1917] rounded-[8px] px-7 py-3.5 text-base font-medium hover:bg-[#1C1917] hover:text-white transition-colors";

export function BelievingHappyHero() {
  return (
    <section data-testid="believing-happy-hero" className="relative bg-[#FAFAF8]">
      <div className="relative w-full reveal pb-[45px] lg:pb-[45px]">
        {/* Desktop image half-band, right side, bleeds to the viewport's
            top/right/bottom edge (About Hero pattern). Only the inner
            (left) edge is feathered into the section's #FAFAF8 bg. */}
        <div className="hidden lg:block absolute inset-y-0 right-0 w-[52%]">
          <FeatheredImage
            src={IMG}
            alt={ALT}
            testId="believing-happy-hero-image"
            objectPosition="50% 14%"
            featherLeft={40}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile image stacked on top */}
        <div className="lg:hidden relative w-full aspect-[4/3] mt-6">
          <FeatheredImage
            src={IMG}
            alt={ALT}
            testId="believing-happy-hero-image-mobile"
            objectPosition="50% 12%"
            featherBottom={20}
            className="absolute inset-0"
          />
        </div>

        {/* Text on the clean left */}
        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 pt-10 lg:pt-0 flex items-center lg:min-h-[min(78vh,680px)]">
          <div className="w-full lg:w-[52%]">
            <div className="max-w-[520px]">
              <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-4">
                Believing Happy
              </p>
              <h1
                data-testid="believing-happy-hero-headline"
                className="font-display text-[34px] sm:text-[46px] lg:text-[54px] leading-[1.12] tracking-tight text-[#1C1917]"
              >
                What if you had a crush on your life again?
              </h1>
              <div className="mt-6 space-y-1 text-[22px] md:text-[26px] leading-snug text-[#57534E]">
                <p>Not because every part of it was perfect.</p>
                <p className="text-[#1C1917]">Because it felt like yours.</p>
              </div>
              <p className="mt-5 text-base md:text-lg leading-relaxed text-[#57534E] max-w-lg">
                Believing Happy is a 10-week Blueprint4Joy&reg; experience to
                get radically honest about where you are, get clear about
                what you really want and start bridging the gap between the
                two.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4">
                <button
                  type="button"
                  data-testid="believing-happy-hero-cta-primary"
                  className={btnPrimary}
                >
                  Join the Next Group &mdash; $800
                </button>
                <button
                  type="button"
                  data-testid="believing-happy-hero-cta-secondary"
                  className={btnSecondary}
                >
                  Explore Private Coaching
                </button>
              </div>
              <p
                data-testid="believing-happy-hero-microcopy"
                className="mt-5 text-sm text-[#8A8580] italic"
              >
                10 weeks &middot; Weekly coaching calls &middot; And yes,
                there&rsquo;s homework
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
